export const TEXT_LOCALE_ZHCHS = {
    yes: 'æ¯',
    no: 'å¦',
    zoom: 'å¨æå¼çå¯¹è¯æ¡ä¸­ç¼è¾åå®¹',
    comments: {
        title: 'å¸¸ç¨æè§',
        manager: 'æè§ç®¡ç',
        empty: 'ææ æ°æ®'
    }
};
